type QueryParamValue =
  | string
  | number
  | boolean
  | string[]
  | number[]
  | null
  | undefined;

export function buildQueryParams(params: object): string {
  const queryParams = new URLSearchParams();

  for (const [key, value] of Object.entries(params) as [
    string,
    QueryParamValue,
  ][]) {
    if (value == null) continue;

    const paramKey = key.replace(/[A-Z]/g, (l) => `_${l.toLocaleLowerCase()}`);

    if (Array.isArray(value)) {
      value.forEach((item) =>
        queryParams.append(`${paramKey}[]`, item.toString()),
      );
    } else {
      queryParams.append(paramKey, value.toString());
    }
  }

  return queryParams.toString();
}
